import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppSettings } from 'src/app/app.settings';
import { LocalStorageServiceProvider } from '../local-storage-service/local-storage-service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HttpClientService {
  private commonDeleteOptions = {};
  private commonHttpOptions = {};
  private commonPostOptions = {};

  constructor(
    private httpClient: HttpClient,
    private localStorageService: LocalStorageServiceProvider,
  ) {
    const jwtToken = this.localStorageService.get('JWTToken');
    this.commonHttpOptions = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${jwtToken}`,
      },
      responseType: 'json'
    };
    this.commonDeleteOptions = {
      ...this.commonHttpOptions,
      responseType: 'text',
    };
    this.commonPostOptions = {
      ...this.commonHttpOptions,
      responseType: 'text',
    };
  }

  delete(url: string, body: any, options: any = {}) {
    return this.httpClient.delete(url, { ...this.commonDeleteOptions, ...options });
  }

  deleteFromWallitApi(relativePath: string, options: any = {}) {
    return this.delete(`${AppSettings.getEndpoint()}${relativePath}`, options);
  }

  get(url: string, options: any = {}) {
    return this.httpClient.get(
      url,
      { ...this.commonHttpOptions, responseType: 'json', ...options }
    ) as Observable<Record<string, any>>;
  }

  getFromWallitApi(relativePath: string, options?: any) {
    return this.get(`${AppSettings.getEndpoint()}${relativePath}`, options);
  }

  post(url: string, body: any, options: any = {}) {
    return this.httpClient.post(url, body, { ...this.commonPostOptions, ...options });
  }

  postToWallitApi(relativePath: string, body: any, options?: any) {
    return this.post(`${AppSettings.getEndpoint()}${relativePath}`, body, options);
  }
}
